/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Stats_Validation_ErrorsInputs */



/**
* | output |
* | --- |
* | "Validation Errors" |
*
* @param {Api_Keys_Stats_Validation_ErrorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_stats_validation_errors = /** @type {((inputs?: Api_Keys_Stats_Validation_ErrorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Stats_Validation_ErrorsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Validierungsfehler")
	return /** @type {LocalizedString} */ ("Validation Errors")
});